<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">收费设置</div>
        <div class="nav-right">
          <span class="nav-lable" @click="rules()">规则</span>
          <img src class="nav-img none" />
        </div>
      </div>
      <ul class="menu-block">
        <li class="item ub ub-ver" >
          <div class="ub ub-pc menu-item" @click="modify_user('chat')">
            <div class="ub-ae ub-f1 menu-item-name">聊天收费</div>
            <div class="ub ub-pc ub-ac">
                <div class="state">{{ chat_info[chosed_chat].txt }}</div>
              <img src="../../assets/img/箭头.png" class="menu-right-icon" />
            </div>
          </div>
          <div class="menu-line"></div>
          <div class="item-tip">
            <span>{{ chat_info[chosed_chat].tip }}</span>
          </div>
        </li>

        <li class="item ub ub-ver">
          <div class="ub ub-pc menu-item" @click="modify_user('voice')">
            <div class="ub-ae ub-f1 menu-item-name">语音收费</div>
    
            <div class="ub ub-pc ub-ac">
              <div class="state">{{ voice_info[chosed_voice].txt }}</div>
              <img src="../../assets/img/箭头.png" class="menu-right-icon" />
            </div>
          </div>
          <div class="menu-line"></div>
          <div class="item-tip">
            <span>{{ voice_info[chosed_voice].tip }}</span>
          </div>
        </li>

        <div class="tip-block">
          <span>收费设置说明:</span>
          <p>聊天收费设置，需要满足一定的魅力值，魅力值越高可设置的收费标准也越高。</p>
          <p>不建议大家设置过高的收费标准，以免吓跑了对方，最后导致无天可聊。建议设置适当的收费标准，可以过滤掉部分用户，从而减少骚扰信息。</p>
          <p>为了更好的用户体验，聊天收费每天最多可修改一次。</p>
        </div>
      </ul>

      <alert ref="myConfirm" ></alert>
      <ryt-dropdown v-model="rytDropdown_chatMny" :actions="actions_chat" :center="rytDropdown_chatMny" @clickOption="chooseOption_chat" title="聊天收费设置" cancelText="关闭/取消" cancenTextColor="rgb(250,242,250)"></ryt-dropdown>
      <ryt-dropdown v-model="rytDropdown_voiceMny" :actions="actions_voice" :center="rytDropdown_voiceMny" @clickOption="chooseOption_voice" title="语音收费设置" cancelText="关闭/取消" cancenTextColor="rgb(250,242,250)"></ryt-dropdown>
     
    </div>
  </template>
  
  <script>
    import { mapMutations, mapActions } from "vuex";
    import * as tool from "../../api/common";
    import rytDropdown from "../../components/Dropdown.vue"; //下拉框带popup蒙层
    import Alert from "../../components/Form.vue";
    export default {
      components: {
        alert: Alert,
        rytDropdown
      },
  
      data() {
        return {
          theme_dark: false,
          rytDropdown_chatMny: false,
          actions_chat: {
            0: "免费",
            20: "20金币/条",
            30: "30金币/条",
            50: "50金币/条",
          },
          rytDropdown_voiceMny: false,
          actions_voice: {
            0: "免费",
            100: "100金币/条",
            300: "300金币/条",
            500: "500金币/条",
          },
          user_info: {},
          chosed_chat:"0",
          chosed_voice:"0",

          chat_info:{
            "0":{"txt":"免费", "tip":"对方跟你聊天免金币，相应的你没有聊天收益", "min_score":0},
            "20":{"txt":"20金币/条", "tip":"对方跟你聊天需要支付20金币/消息，相应的你可获得20积分","min_score":10000},
            "30":{"txt":"30金币/条", "tip":"对方跟你聊天需要支付30金币/消息，相应的你可获得30积分","min_score":50000},
            "50":{"txt":"50金币/条", "tip":"对方跟你聊天需要支付50金币/消息，相应的你可获得50积分","min_score":100000}
          },

          voice_info:{
            "0":{"txt":"免费", "tip":"对方播放你的语音免金币，相应的你没有语音收益", "min_score":0},
            "100":{"txt":"100金币/条", "tip":"对方播放你的语音需要支付100金币/条，相应的你可获得100积分","min_score":10000},
            "300":{"txt":"300金币/条", "tip":"对方播放你的语音需要支付300金币/条，相应的你可获得300积分","min_score":50000},
            "500":{"txt":"500金币/条", "tip":"对方播放你的语音需要支付500金币/条，相应的你可获得500积分","min_score":100000}
          },

        };
      },
      mounted() {
        //切换深色模式
        this.theme_dark = tool.is_theme_dark(this);
        this.init_page();
      },
      methods: {
        ...mapMutations(["get", "post"]), //引入方法
        ...mapActions(["act_get_userinfo","act_reload_userinfo"]), //引入方法
        back() {
          this.$router.go(-1); //返回上一层
        },
        init_page() {
          var uid = this.$store.state.uid;
          var self = this;
  
          self.act_get_userinfo({
            uid: uid,
            success: function (u) {
                self.user_info = u;
                self.chosed_chat = u.chat_mny_score + '';
                self.chosed_voice = u.chat_mny_score2 + '';
            }
          });
  
        },

        //规则
        rules() {
          var self = this;
          var h =
            '<div style="display: flex; flex-direction: column; font-size:.9rem; overflow:scroll;width: 99.5%;height:30rem;border-radius:.3em;color: #888;">'  +
            "<span></span>" +
            "<span>如果设置了聊天收费，对方每发一条消息需要支付相应的金币（你设置的金币），你及时回复消息将得到相应的积分，回复消息越及时得积分越高。</span>" +
            "<span style='margin-top:0.5rem;'>打招呼阶段对方不扣金币，相应的你不得积分；过了打招呼阶段，对方扣金币，你得积分。</span>" +
            "<span style='margin-top:1rem;'>语音收费规则</span>" +
            "<span>你发送给对方的语音消息，对方收听需要支付金币（你设置的金币数值），相应的你可得积分。</span>" +
            "<span style='margin-top:0.5rem;'>举例说明：你设置了语音收费300金币，那么你发送一条语音给对方，对方播放了你的语音，对方需要支付300金币，同时你得到300积分，如果对方没有播放你的语音，则没有积分收益。</span>" +
            "<span style='margin-top:1rem;'>所有收费标准的设置，都是由当前的用魅力值以及最近24小时的魅力值决定的，魅力值越高可设置的收费标准也越高。</span>" +
            "<span style='margin-top:1rem;'>最后，平台禁止一切作弊行为，一经发现必严惩不贷，违规收益全部扣除，情节严重者将面临封号处罚。</span>" 
            + '</div>';
          self.$refs.myConfirm.show(h, {
            type: "alert",
            confirmText: "知道了",
            titleText: "收费设置规则",
            data: ""
          });
        },
        
        modify_user(field) {
            if (field == "chat") {
                this.rytDropdown_chatMny = true;
                this.rytDropdown_voiceMny = false;
            }
            if (field == "voice") {
                this.rytDropdown_voiceMny = true;
                this.rytDropdown_chatMny = false;
            }
        },
        

      
        chooseOption_chat(e) {
            var score = e.index;
            
            //第一，检测
            if (!this.check_chat(score)) {
              return false;
            }

            //第二步，设置值
            this.chosed_chat = score + '';
            
            //第三步，更新
            var send_data = { "chat_mny_score": this.chosed_chat };
            var data = {
              "send_data": send_data,
              "suc": function() {
                localStorage.setItem("loc_set_chatScore", new Date().getTime());
              }
            }
            this.update_user_info(data);
        },

        check_chat(score) {
          var rtn = true;

            //没有更换
            if (score == this.user_info.chat_mny_score) {
              this.$toast.center("请选择新的选项");
              return false;
            }

            //免费直接设置
            if (score == 0) {
              rtn = true;
              return rtn;
            }

            var loc_set_chatScore = localStorage.getItem("loc_set_chatScore");
            if (loc_set_chatScore != null) {
              var dtm_old = JSON.parse(loc_set_chatScore);
              var dtm_old = parseInt(dtm_old);
              var dtm = new Date().getTime();
              var timeDiff = dtm - dtm_old; // 计算时间差

              if (timeDiff < 24 * 60 * 60 * 1000) {
                  this.$toast.center("每天只能修改一次哦~");
                  rtn = false;
                  return rtn;
              }
            }


            //新用户可设置20积分
            if (this.user_info.reg_time <= 86400 * 1 && this.user_info.sex == "女生") {
              if(score <= 20){
                rtn = true;
                return rtn;
              }else{
                this.$toast.center("萌新用户，从小开始，别选太大~");
                rtn = false;
                return rtn;
              }
            }
            
            var min_score = this.chat_info[score+""].min_score;
            var my_score = this.user_info.score_total;
            if(my_score < min_score){
              this.$toast.center("魅力值不足~");
              rtn = false;
              return rtn;
            }
          return rtn;
        },
        
        chooseOption_voice(e) {
            var score = e.index;
            
            //第一步，检测
            if (!this.check_voice(score)) {
              return false;
            }

            //第二，设置值
            this.chosed_voice = score + '';
            
            var send_data = { "chat_mny_score2": this.chosed_voice };
            var data = {
              "send_data": send_data,
              "suc": function() {
                localStorage.setItem("loc_set_VoiceScore", new Date().getTime());
              }
            }
            this.update_user_info(data);
        },
        check_voice(score) {
          var rtn = true;

            //没有更换
            if (score == this.user_info.chat_mny_score2) {
              this.$toast.center("请选择新的选项");
              return false;
            }

            //免费直接设置
            if (score == 0) {
              rtn = true;
              return rtn;
            }

            var loc_set_VoiceScore = localStorage.getItem("loc_set_VoiceScore");
            if (loc_set_VoiceScore != null) {
              var dtm_old = JSON.parse(loc_set_VoiceScore);
              var dtm_old = parseInt(dtm_old);
              var dtm = new Date().getTime();
              var timeDiff = dtm - dtm_old; // 计算时间差

              if (timeDiff < 24 * 60 * 60 * 1000) {
                  this.$toast.center("每天只能修改一次哦~");
                  rtn = false;
                  return rtn;
              }
            }
            
            var min_score = this.voice_info[score+""].min_score;
            var my_score = this.user_info.score_total;
            if(my_score < min_score){
              this.$toast.center("魅力值不足~");
              rtn = false;
              return rtn;
            }
          return rtn;
        },

        update_user_info(data) {
              var self = this;
              var uid = this.$store.state.uid;
              
              var data2 = {
                  url: "/App/User_ModifyBaseInfo",
                  data: {
                    uid: uid,
                    data: JSON.stringify(data.send_data),
                  },
                  success: function (data_serve) {
                  if (data_serve.state == "1") {
                      data.suc(data_serve);
                      self.$toast.center("设置成功");
                      self.act_reload_userinfo({
                        'uid': uid,
                        success: function (info) {
                          self.user_info = info;
                        }
                      });
                  }
                  },
              };
              self.post(data2);
        }
      }
    };
  </script>
  
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
  }
  .nav-right {
    padding-right: 0.5rem;
    .nav-lable {
      margin: 0;
      font-size: 0.9rem;
      color: #fff;
    }
  }
    .menu-block {
      margin: 0 0.8rem;
      margin-top: 0.5rem;
      .item {
        padding: 0.5rem 0.8rem;
        margin-bottom: 0.5rem;
        background-color: #fff;
        border-radius: 0.5rem;
      }
      .menu-item {
        height: 3rem;
        .menu-item-name{
          font-size: .95rem;
        }
        .state {
          margin-right: .3rem;
          font-size: .95rem;
          color: #9e9e9e;
        }
  
        .state-color {
          font-size: .95rem;
          color: #03fd20;
        }
        .menu-right-icon {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
      .item-tip {
        margin-top: 0.5rem;
          span {
            font-size: 0.75rem;
            color: #e92162;
          }
      }
      .menu-line {
        border-top: 1px solid #EFEFEF;
      }
    }

    .tip-block {
        margin-top: 0.5rem;
        padding: 0.5rem 0.5rem;
        border-radius: 0.5rem;
        color: #999;
        font-size: 0.75rem;
    }
  
    .container-dark {
      min-height: 100vh;
      background-color: #2f2e33;
      .menu-block {
        .item {
          background-color: #38363f;
        }
        .menu-item {
          .menu-item-name {
            color: #DFDFDF;
          }
        }
      }
      .menu-line {
        border-top: 1px solid #404040;
      }
    }
  </style>